import { SportsTennis } from "@material-ui/icons";
import { toast } from "react-toastify";
const sportIdsInMLBDiamond = [1, 22, 586];

class GameActionStore {
  constructor(clippyApi, jaredApi, veracityApi, trackingAccuracyReportSource) {
    this.clippyApi = clippyApi;
    this.jaredApi = jaredApi;
    this.veracityApi = veracityApi;
    this.trackingAccuracyReportSource = trackingAccuracyReportSource;
  }

  clearClippyCache = (gamePk) => {
    return this.clippyApi
      .clearCache(gamePk)
      .then(() => {
        toast(`Clippy cache has been cleared.`);
        this.trackingAccuracyReportSource.fetchData();
      })
      .catch((err) =>
        toast.error(`Error: Clippy cache has not been cleared due to ${err}`, {
          autoClose: false,
        }),
      );
  };

  clearStatsApiCache = (gamePk) => {
    return this.jaredApi
      .clearApiCache(gamePk)
      .then(() => {
        toast(`StatsApi cache has been cleared.`);
        this.trackingAccuracyReportSource.fetchData();
      })
      .catch((err) =>
        toast.error(
          `Error: StatsApi cache has not been cleared due to ${err}`,
          {
            autoClose: false,
          },
        ),
      );
  };

  resendGame = (gamePk, feedType, isMlbVenue, sportId) => {
    const effectiveSportId =
      sportId !== undefined && sportId !== null
        ? sportId
        : isMlbVenue
          ? 1
          : null;
    if (effectiveSportId === null) {
      toast.error(
        "Cannot resend game: missing sport information for this game.",
        { autoClose: false },
      );
      return Promise.resolve();
    }

    let mode = "";
    if (isMlbVenue || sportIdsInMLBDiamond.includes(effectiveSportId)) {
      mode = "MLB";
    } else {
      mode = "MiLB";
    }

    return this.jaredApi
      .resendMLBGame(gamePk, feedType, mode)
      .then(() => {
        toast(`Game resend has started.`);
        this.trackingAccuracyReportSource.fetchData();
      })
      .catch((err) =>
        toast.error(`Error: Game has not been resent due to ${err}`, {
          autoClose: false,
        }),
      );
  };
}

export default GameActionStore;
